<script>
    export let name;
    export let image;
    export let imageAlt;
    export let link;
    export let priority = false; // For above-the-fold images
    
    // Generate responsive image URLs
    function getResponsiveImageUrl(baseUrl, width) {
        return baseUrl.replace('/500/', `/${width}/`);
    }
    
    // Generate srcset for responsive images
    $: srcset = `${getResponsiveImageUrl(image, 300)} 300w, ${getResponsiveImageUrl(image, 500)} 500w, ${getResponsiveImageUrl(image, 800)} 800w`;
    
    // Generate sizes attribute for responsive images
    $: sizes = "(max-width: 768px) 50vw, (max-width: 1200px) 25vw, 300px";
</script>

<a href={link} aria-label={name}>
    <img 
        src={image} 
        srcset={srcset}
        sizes={sizes}
        alt={imageAlt}
        loading={priority ? 'eager' : 'lazy'}
        decoding="async"
        width="500"
        height="333"
    />
    <h3>{name}</h3>
</a>

<style>
    a {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        flex: 1;
        overflow: hidden;
        gap: 16px;
        display: block;
        text-decoration: none;
    }

    img {
        width: 100%;
        aspect-ratio: 1.5;
        border-radius: 24px;
        background-color: var(--surface-container);
    }

    h3 {
        font-family: var(--font-body);
        font-size: 20px;
        width: 100%;
        margin: 0;
        padding: 0;
        margin-top: 8px;
    }
    
</style>